import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class CustomMessageService extends MessageService {
  override add(message: any): void {
    // Ignorer les messages d'erreur
    if (message?.severity === 'error') {
      return;
    }
    super.add(message);
  }

  override addAll(messages: any[]): void {
    // Filtrer les messages d'erreur
    const filteredMessages = messages.filter(m => m?.severity !== 'error');
    super.addAll(filteredMessages);
  }
}
